<template>
    <aside class="oy-a pf ath-global-modal" v-if="cfg">
        <div class="pa-f ath-global-modal-bg"
            :class="[UIMobile ? 'c-el-panel-bg' : 'c-el-overlay-dark-bg el--animate']"></div>
        <div class="f fv fa-c fj-sa oy-a pa-f ath-global-modal-container"
            :class="[UIMobile ? 'c-el-panel-bg ox-h' : '']">
            <comp :is="cfg.comp"
                ref="modalEl"
                v-bind="cfg.props"
                @actClose="close"
                tabindex="-1"
                class="ath-global-modal-el"
                :class="[UIMobile ? 'el--mobile br-m' : '']"
                :modalnoshow="cfg.noshow"
                @keydown.esc.native="onEscape"
                @keydown.tab.native="onTabKey" />
        </div>
    </aside>
</template>

<script>
import { guuid } from '@aretheyhappy/utils';
import UIMobileMixin    from '../../mixins/UIMobile';

const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), '
    + 'input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export default {
    name: 'mead-global-modal-container',
    mixins: [UIMobileMixin],
    data () {
        return {
            uid: guuid(),
            cfg: false,
            previouslyFocusedEl: null,
        };
    },
    created () {
        MeadCommon.Flash.subscribe(this.uid, 'global-modal:open', this.open);
        MeadCommon.Flash.subscribe(this.uid, 'global-modal:close', this.close);
    },
    destroyed () {
        MeadCommon.Flash.unsubscribe(this.uid);
    },
    methods: {
        getModalEl () {
            return this.$refs.modalEl && this.$refs.modalEl.$el ? this.$refs.modalEl.$el : this.$refs.modalEl;
        },
        getFocusableEls () {
            const modalEl = this.getModalEl();
            if (!modalEl || !modalEl.querySelectorAll) return [];

            return Array.from(modalEl.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(el => el.offsetParent !== null);
        },
        onEscape () {
            this.close();
        },
        onTabKey (event) {
            const focusable = this.getFocusableEls();
            if (focusable.length === 0) {
                event.preventDefault();
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        },
        open: function (cfg) {
            this.previouslyFocusedEl = document.activeElement;
            this.cfg = cfg;
            MeadCommon.ModalService.setHasModal(true);
            this.$nextTick(() => {
                const focusable = this.getFocusableEls();
                const fallback = this.getModalEl();
                (focusable[0] || fallback).focus();
            });
        },
        close: function (params = false) {
            if (this.cfg.next) this.cfg.next(params);
            this.cfg = false;
            MeadCommon.ModalService.setHasModal(false);
            if (this.previouslyFocusedEl && this.previouslyFocusedEl.focus) {
                this.previouslyFocusedEl.focus();
            }
            this.previouslyFocusedEl = null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.ath-global-modal {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: $zx-modal;
}

.ath-global-modal-bg {
    z-index: calc(#{$zx-page-overlay} - 1);

    &.el--animate {
        opacity: .8;
        animation: overlayBgIn .2s forwards ease-out;
    }
}

.ath-global-modal-container {
    z-index: $zx-page-overlay;
}

.ath-global-modal-el {
    &.el--mobile {
        width: 100vw !important;
        height: 100% !important;
        max-height: 100% !important;
        padding-top: 0;
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
    }

    &:not(.el--mobile) {
        opacity: 0;
        animation: modalIn .2s forwards ease-out;
        transform: translateY(-2rem);
        border-radius: $br-m;
    }
}
</style>
